import { render, staticRenderFns } from "./GroupFinancialTransfer.vue?vue&type=template&id=455a0af4&scoped=true"
import script from "./GroupFinancialTransfer.vue?vue&type=script&lang=js"
export * from "./GroupFinancialTransfer.vue?vue&type=script&lang=js"
import style0 from "./GroupFinancialTransfer.vue?vue&type=style&index=0&id=455a0af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a0af4",
  null
  
)

export default component.exports